import React from 'react';
import { Box, Spinner, Center, Text, VStack } from '@chakra-ui/react';
import { useStateContext } from '../context/ContextProvider';

const Loader = () => {
  const { isLoading } = useStateContext();

  if (!isLoading) return null;

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100vw"
      height="100vh"
      backgroundColor="rgba(0, 0, 0, 0.35)"
      backdropFilter="blur(8px)"
      WebkitBackdropFilter="blur(8px)"
      zIndex="9999"
      display="flex"
      alignItems="center"
      justifyContent="center"
      className="animate-fade-in"
    >
      <VStack spacing={5} className="animate-scale-in">
        <Center
          p={8}
          bg="white"
          borderRadius="20px"
          boxShadow="0 25px 60px -12px rgba(0,0,0,0.2), 0 0 40px -8px rgba(128, 90, 213, 0.1)"
          border="1px solid"
          borderColor="gray.100"
          _dark={{
            bg: "gray.800",
            borderColor: "gray.700",
            boxShadow: "0 25px 60px -12px rgba(0,0,0,0.5), 0 0 40px -8px rgba(128, 90, 213, 0.15)"
          }}
        >
          <Spinner
            thickness="3px"
            speed="0.7s"
            emptyColor="gray.100"
            color="purple.500"
            size="xl"
          />
        </Center>
        <Text
          color="white"
          fontWeight="600"
          fontSize="14px"
          letterSpacing="-0.01em"
          textShadow="0 2px 8px rgba(0,0,0,0.4)"
        >
          Chargement en cours...
        </Text>
      </VStack>
    </Box>
  );
};

export default Loader;
